import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import _productService from 'services/products-services'
import axios from "axios";
import { useEffect, useState } from 'react';

export function useProducts() {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['products',t], async () => {
        const { response } = await _productService.getAll()
        if (response) return response
    })

    return { ...result, products: result.data?? [] , isLoading, isError, isFetching, isSuccess,}
}

export function useProduct(id:any) {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['product',t], async () => {
        const { response } = await _productService.getById(id)
        if (response) return response
    })

    return { ...result, product: result.data?? {} , isLoading, isError, isFetching, isSuccess,}
}

export function useProductsAddon(id:any) {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['products-addon',t], async () => {
        const { response } = await _productService.getAppAddon(id)
        if (response) return response
    })

    return { ...result, productsAddon: result.data?? [] , isLoading, isError, isFetching, isSuccess}
}

export function useAddonById(id:any) {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['addon-details',t], async () => {
        const { response } = await _productService.getAddonById(id)
        if (response) return response
    })

    return { ...result, productsAddon: result.data?? [] , isLoading, isError, isFetching, isSuccess,}
}

export function useProductsReleases(id:any) {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['products-releases',t], async () => {
        const { response } = await _productService.getAppReleases(id)
        if (response) return response
    })

    return { ...result, productsReleases: result.data?? {} , isLoading, isError, isFetching, isSuccess,}
}

export function useReasonsDevices() {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['reasons-changes',t], async () => {
        const { response } = await _productService.getReasons()
        if (response) return response
    })

    return { ...result, reasonsChanges: result.data?? {} , isLoading, isError, isFetching, isSuccess,}
}

export function useCustomerSubscription(id:any) {
    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['subscription',id], async () => {
        const { response } = await _productService.getCustomerSubscription(id)
        if (response) return response
    })

    return { ...result, subscription: result.data?? {} , isLoading, isError, isFetching, isSuccess,}
}


export function useLicenses(id:any) {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['licenses',id], async () => {
        const { response } = await _productService.getLicenses(id)
        if (response) return response
    })

    return { ...result, licenses: result.data?? {} , isLoading, isError, isFetching, isSuccess,}
}

export function useIP() {
  const [ip, setIP] = useState("");

    const getData = async () => {
        const res = await axios.get("https://geolocation-db.com/json/");
        setIP(res.data.IPv4);
      };
      useEffect(() => {
        getData();
      }, []);
    return ip
}